import { render } from "./locator.vue?vue&type=template&id=590ca777&scoped=true"
import script from "./locator.vue?vue&type=script&lang=js"
export * from "./locator.vue?vue&type=script&lang=js"

import "./locator.vue?vue&type=style&index=0&id=590ca777&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590ca777"]])

export default __exports__